export const getConsoleUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_CONSOLE_PROD_URL
    : process.env.REACT_APP_CONSOLE_DEV_URL;

export const getGatewayUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_GATEWAY_PROD_URL
    : process.env.REACT_APP_GATEWAY_DEV_URL;

export const getAuthUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_AUTH_PROD_URL
    : process.env.REACT_APP_AUTH_DEV_URL;

export const getAuthServerUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_AUTH_SERVER_PROD_URL
    : process.env.REACT_APP_AUTH_SERVER_DEV_URL;

export const getAuthRedirectUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_AUTH_REDIRECT_PROD_URL
    : process.env.REACT_APP_AUTH_REDIRECT_DEV_URL;

export const getLocationSocketUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_LOCATION_SOCKET_PROD_URL
    : process.env.REACT_APP_LOCATION_SOCKET_DEV_URL;

export const getNotificationSocketUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_NOTIFICATION_SOCKET_PROD_URL
    : process.env.REACT_APP_NOTIFICATION_SOCKET_DEV_URL;

export const getFinanceAnalyticsUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_METABASE_FINANCE_ANALYTICS_PROD_URL
    : process.env.REACT_APP_METABASE_FINANCE_ANALYTICS_DEV_URL;

export const getLiveAnalyticsUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_METABASE_LIVE_ANALYTICS_PROD_URL
    : process.env.REACT_APP_METABASE_LIVE_ANALYTICS_DEV_URL;

export const getMapAPIKey = () => process.env.REACT_APP_MAP_API_KEY;


export const getAiChatUrl =()=>
  process.env.NODE_ENV === "production"
     ? process.env.REACT_APP_AI_CHAT_PROD_URL
     : process.env.REACT_APP_AI_CHAT_DEV_URL
 